// The taster's lead (landing spec §6: its two lines are in the copy list)
// and the line that follows a resolved drawing. The framed beat itself is
// composed app-side (`app/_components/taster`) and renders this beside it.
export function TasterLead({ done }: { done: boolean }) {
    return (
        <div>
            <h3 className="font-serif text-lp-title text-ink md:text-lp-title-md">
                Now you — draw <em className="italic">old</em>.
            </h3>
            <p className="mt-4 max-w-[38ch] font-serif text-lp-lede text-body-fg">
                Frame 16, from its keyword. The square and the grader are the
                app’s own.
            </p>
            {done ? (
                <p className="mt-4 font-serif text-lp-copy text-muted-fg italic">
                    That is one frame of 2,200. The door above opens the first.
                </p>
            ) : null}
        </div>
    )
}
